/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Domain,
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
} from './Domain';
import {
    FundamentalDomain,
    FundamentalDomainFromJSON,
    FundamentalDomainFromJSONTyped,
    FundamentalDomainToJSON,
} from './FundamentalDomain';
import {
    IndicatorTypeEnum,
    IndicatorTypeEnumFromJSON,
    IndicatorTypeEnumFromJSONTyped,
    IndicatorTypeEnumToJSON,
} from './IndicatorTypeEnum';
import {
    IndicatorValueTypeEnum,
    IndicatorValueTypeEnumFromJSON,
    IndicatorValueTypeEnumFromJSONTyped,
    IndicatorValueTypeEnumToJSON,
} from './IndicatorValueTypeEnum';
import {
    ScienceBranch,
    ScienceBranchFromJSON,
    ScienceBranchFromJSONTyped,
    ScienceBranchToJSON,
} from './ScienceBranch';

/**
 * 
 * @export
 * @interface IndicatorAddDTO
 */
export interface IndicatorAddDTO {
    /**
     * 
     * @type {string}
     * @memberof IndicatorAddDTO
     */
    fundamentalDomainId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IndicatorAddDTO
     */
    scienceBranchId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IndicatorAddDTO
     */
    domainId?: string | null;
    /**
     * 
     * @type {IndicatorTypeEnum}
     * @memberof IndicatorAddDTO
     */
    indicatorType?: IndicatorTypeEnum;
    /**
     * 
     * @type {IndicatorValueTypeEnum}
     * @memberof IndicatorAddDTO
     */
    indicatorValueType?: IndicatorValueTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IndicatorAddDTO
     */
    indicatorValue?: number;
    /**
     * 
     * @type {FundamentalDomain}
     * @memberof IndicatorAddDTO
     */
    fundamentalDomain?: FundamentalDomain;
    /**
     * 
     * @type {ScienceBranch}
     * @memberof IndicatorAddDTO
     */
    scienceBranch?: ScienceBranch;
    /**
     * 
     * @type {Domain}
     * @memberof IndicatorAddDTO
     */
    domain?: Domain;
}

export function IndicatorAddDTOFromJSON(json: any): IndicatorAddDTO {
    return IndicatorAddDTOFromJSONTyped(json, false);
}

export function IndicatorAddDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndicatorAddDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fundamentalDomainId': !exists(json, 'fundamentalDomainId') ? undefined : json['fundamentalDomainId'],
        'scienceBranchId': !exists(json, 'scienceBranchId') ? undefined : json['scienceBranchId'],
        'domainId': !exists(json, 'domainId') ? undefined : json['domainId'],
        'indicatorType': !exists(json, 'indicatorType') ? undefined : IndicatorTypeEnumFromJSON(json['indicatorType']),
        'indicatorValueType': !exists(json, 'indicatorValueType') ? undefined : IndicatorValueTypeEnumFromJSON(json['indicatorValueType']),
        'indicatorValue': !exists(json, 'indicatorValue') ? undefined : json['indicatorValue'],
        'fundamentalDomain': !exists(json, 'fundamentalDomain') ? undefined : FundamentalDomainFromJSON(json['fundamentalDomain']),
        'scienceBranch': !exists(json, 'scienceBranch') ? undefined : ScienceBranchFromJSON(json['scienceBranch']),
        'domain': !exists(json, 'domain') ? undefined : DomainFromJSON(json['domain']),
    };
}

export function IndicatorAddDTOToJSON(value?: IndicatorAddDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fundamentalDomainId': value.fundamentalDomainId,
        'scienceBranchId': value.scienceBranchId,
        'domainId': value.domainId,
        'indicatorType': IndicatorTypeEnumToJSON(value.indicatorType),
        'indicatorValueType': IndicatorValueTypeEnumToJSON(value.indicatorValueType),
        'indicatorValue': value.indicatorValue,
        'fundamentalDomain': FundamentalDomainToJSON(value.fundamentalDomain),
        'scienceBranch': ScienceBranchToJSON(value.scienceBranch),
        'domain': DomainToJSON(value.domain),
    };
}

